export const topProducts = [
  {
    id: 1,
    thumbnail:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/1.webp',
    title: 'Classic Casio Watch',
    description: 'Watch',
    price: '$1,290.00',
    rating: [4, 4.5, 5],
  },
  {
    id: 2,
    thumbnail:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/2.webp',
    title: 'New Wireless Headphone',
    description: 'Apple Headphone',
    price: '$1000.00',
    rating: [3, 4, 5],
  },
  {
    id: 3,
    thumbnail:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/3.webp',
    title: 'Marc Jacob’s Decadent',
    description: 'Home Decor',
    price: '$220.00',
    rating: [2, 3, 5],
  },
  {
    id: 4,
    thumbnail:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/4.webp',
    title: 'Classic Heels For Women',
    description: 'Gadgets',
    price: '$150.90',
    rating: [4, 4.5, 5],
  },
  {
    id: 5,
    thumbnail:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/5.webp',
    title: 'Apple Watch Strap',
    description: 'Accessories',
    price: '$20.00',
    rating: [4, 4.5, 5],
  },
  {
    id: 6,
    thumbnail:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/6.webp',
    title: 'Nike Air SHoe',
    description: 'Fashion',
    price: '$220.00',
    rating: [4, 4.5, 5],
  },
  {
    id: 7,
    thumbnail:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/7.webp',
    title: 'Shoes',
    description: 'Fashion',
    price: '$150.90',
    rating: [4, 4.5, 5],
  },
  {
    id: 8,
    thumbnail:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/8.webp',
    title: 'Perfume',
    description: 'Fashion',
    price: '$70.00',
    rating: [4, 4.5, 5],
  },
];

export const topProductList = [
  {
    id: 1,
    thumbnail:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/1.webp',
    title: 'Casio Watch',
    description: 'Watch',
    price: '$1,290.00',
    rating: [4, 4.5, 5],
  },
  {
    id: 2,
    thumbnail:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/2.webp',
    title: 'Apple Headphone',
    description: 'Apple Headphone',
    price: '$1000.00',
    rating: [3, 4, 5],
  },
  {
    id: 3,
    thumbnail:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/3.webp',
    title: 'Marc Decadent',
    description: 'Home Decor',
    price: '$220.00',
    rating: [2, 3, 5],
  },
  {
    id: 4,
    thumbnail:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/4.webp',
    title: 'Classic Heels',
    description: 'Gadgets',
    price: '$150.90',
    rating: [4, 4.5, 5],
  },
  {
    id: 5,
    thumbnail:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/5.webp',
    title: 'Apple Watch',
    description: 'Accessories',
    price: '$20.00',
    rating: [4, 4.5, 5],
  },
  {
    id: 6,
    thumbnail:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/6.webp',
    title: 'Nike Air SHoe',
    description: 'Fashion',
    price: '$220.00',
    rating: [4, 4.5, 5],
  },
  {
    id: 7,
    thumbnail:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/products/modern/7.webp',
    title: 'Blue Jacket',
    description: 'Fashion',
    price: '$150.90',
    rating: [4, 4.5, 5],
  },
];
